import { createAction } from "@reduxjs/toolkit";
import {
  PlayerReportRequestPayload,
  UpdateProfilePayload,
  UserProfile,
  UserStatistics,
} from "../types";
export type RegisterPayload = {
  firstName: string;
  lastName: string;
  dateOfBirth: string; // ISO string
  mobileNumber: string;
  email: string;
  password: string;
  invitedBy?: string;
  username: string;
  nickname: string;
  remarks?: string;
};

export const updateUserVipStatus = createAction<{
  isVip: boolean;
  vipExpiredAt?: number;
}>("auth/updateUserVipStatus");

export const loginRequest = createAction<{
  username: string;
  password: string;
}>("auth/loginRequest");
export const loginSuccess = createAction<{ token: string; user: any }>(
  "auth/loginSuccess",
);
export const loginFailure = createAction<string>("auth/loginFailure");

export const logout = createAction("auth/logout");

export const registerRequest = createAction<RegisterPayload>(
  "auth/register/request",
);
export const registerSuccess = createAction("auth/register/success");
export const registerFailure = createAction<string>("auth/register/failure");

export const checkAuthRequest = createAction("auth/checkAuthRequest");
export const checkAuthSuccess = createAction<{ token: string; user?: any }>(
  "auth/checkAuthSuccess",
);
export const checkAuthFailure = createAction("auth/checkAuthFailure");

export const rehydrateAuth = createAction<{
  token?: string;
  user?: UserProfile;
}>("auth/rehydrate");

export const profileRequest = createAction("auth/profileRequest");
export const profileSuccess = createAction<UserProfile>("auth/profileSuccess");
export const profileFailure = createAction<string>("auth/profileFailure");

export const userStatsRequest = createAction("auth/userStatsRequest");
export const userStatsSuccess = createAction<UserStatistics>(
  "auth/userStatsSuccess",
);
export const userStatsFailure = createAction<string>("auth/userStatsFailure");

export const updateProfileRequest = createAction<UpdateProfilePayload>(
  "auth/profile/update/request",
);

export const updateProfileSuccess = createAction("auth/profile/update/success");
export const updateProfileFailure = createAction<string>(
  "auth/profile/update/failure",
);

export const reportUserRequest = createAction<PlayerReportRequestPayload>(
  "auth/reportUserRequest",
);

export const reportUserSuccess = createAction("auth/reportUserSuccess");

export const reportUserFailure = createAction<string>("auth/reportUserFailure");

export const facebookLoginRequest = createAction("auth/facebookLoginRequest");

export const facebookLoginSuccess = createAction<{ token: string; user: any }>(
  "auth/facebookLoginSuccess",
);

export const facebookLoginFailure = createAction<string>(
  "auth/facebookLoginFailure",
);

export const googleLoginRequest = createAction("auth/googleLoginRequest");

export const googleLoginFailure = createAction<string>(
  "auth/googleLoginFailure",
);
